export default __webpack_public_path__ + "static/cosmeticCLCEO-ab49e744-6f1b8fc1e8b3773463d2c6a0d9ef6aab.webp";